import { type ShippingTermConstructor } from '../../entities/ShippingTerm'
import { type ShippingTermApiModel } from '../api-models/ShippingTermApiModel'

export const mapShippingTermApiModel = (
  data: ShippingTermApiModel
): ShippingTermConstructor => ({
  id: data.id,
  name: data.name,
  description: data.description,
  active: data.active,
})
